import { INSUFFICIENT_BALANCE_CODE } from './useAddFundsAction';

/** Resolves the operator's `LowBalance.visibility` knob, `shown` when unset (index.css). */
const LOW_BALANCE_SWITCH = '--ui-low-balance';
const HIDDEN = 'hidden';

/**
 * True when a short balance is the host's to answer: the failure is
 * INSUFFICIENT_BALANCE and the operator hid our message in the Design
 * Constructor, because its site opens its own top-up popup on
 * `purchase_failed` / `shipping_failed`. Ours on top would be a second one.
 */
export function isLowBalanceLeftToHost(code: string | undefined): boolean {
  if (code !== INSUFFICIENT_BALANCE_CODE || typeof document === 'undefined') return false;
  return getComputedStyle(document.documentElement).getPropertyValue(LOW_BALANCE_SWITCH).trim() === HIDDEN;
}
